import React from "react";
import Context from "shared/util/Context";

import Carousel, {
	CarouselItem,
} from "apps/payment/components/Carousel";
import { DESCRIPTIONS } from "../util/constants";

import "./Description.scss";

const incognitoBanditRelativePath = "media/img/illustrations/wright-png/incognito/large@2x.png";
const incognitoBandit = `${Context.get("cssImagePath")}${incognitoBanditRelativePath}`;

const Description = () => (
	<div className="incognitopackages-description">
		<img
			alt="Get ultimate privacy. Go incognito!"
			className="incognitopackages-description-image"
			src={incognitoBandit}
		/>

		<Carousel>
			{DESCRIPTIONS.map((description, index) => (
				<CarouselItem
					key={description.header}
					index={index}
					totalItemCount={DESCRIPTIONS.length}
				>
					<h2 className="incognitopackages-description-header">
						{description.header}
					</h2>
					<p className="incognitopackages-description-paragraph">
						{description.paragraph}
					</p>
				</CarouselItem>
			))}
		</Carousel>
	</div>
);

export default Description;



// WEBPACK FOOTER //
// ./src/apps/incognito_packages/components/Description.jsx